import { ReportType } from "./typings/global";
export const GConfig: ReportType.GConfig = {
  /**
   * Debug
   */
  Debug: false,

  /**
   * 上报间隔
   */
  ReportFreq: 1000,

  /**
   * 打开上报
   */
  OpenReport: true,

  /**
   * 上报域名
   */
  RepotHost: "https://metric.huya.com",

  /**
   * 平台定义上报方法
   */
  PlatformRequest: undefined,

  /**
   * 基础信息
   */
  BaseInfo: { ua: "", uid: 0 },

  /**
   * 默认上报 Dim 数据
   */
  DefDimInfo: {},

  /**
   * 默认上报 Field 数据
   */
  DefFieldInfo: {},
};
